import CityPageTemplate from "../city-template/CityPageTemplate";
import { stAlbansConfig } from "./data";

export default function StAlbansPage() {
  return <CityPageTemplate config={stAlbansConfig} />;
}